<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">{{ $t('view')}} {{ $t('addons') }}</div>
      <div>
        <a href class="btn-blue" @click.prevent.stop="goToRoute">{{ $t('edit')}} {{ $t('addons') }}</a>
        <router-link class="btn-blue" to="add-ons">{{ $t('addons') }} {{ $tc('list', 2) }}</router-link>
      </div>
    </div>

    <div class="all-details-container">
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $tc('cinema', 2) }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10">{{ selectedCinema }}</div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('addonItemName') }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10">{{ add_on_object.add_on_item_name }}</div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('addonItemDescription') }}</div>
              <div
                class="col-md-9 col-lg-10 col-xl-10"
              >{{ add_on_object.add_on_item_description || '-' }}</div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $tc('unitofmeasurement',2) }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10">{{ selectedUom }}</div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('maxQty') }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10">{{ add_on_object.add_on_max_quantity}}</div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('itemPrice') }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10">{{ add_on_object.add_on_item_price}}</div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('isSundry') }}</div>
              <div
                class="col-md-9 col-lg-10 col-xl-10"
              >{{ add_on_object.is_sundry_item == 'Y' ? $t('Yes'): $t('No') }}</div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $tc('status', 1) }}</div>
              <div
                class="col-md-9 col-lg-10 col-xl-10"
              >{{ add_on_object.add_on_is_active == 'Y' ? $t('active'): $t('not') + ' '+$t('active') }}</div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('createdby') }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                <span>{{ created_by }}</span>
              </div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('createdat') }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                <span class="mr-3">{{ add_on_object.created_at | dateparse }}</span>
              </div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('modifiedby') }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                <span>{{ updated_by }}</span>
              </div>
            </div>
          </div>

          <div class="col-md-12 py-2">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('modifiedat') }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                <span class="mr-3">{{ add_on_object.updated_at | dateparse }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import MasterService from "@/services/MasterService";
import CinemasService from "@/services/CinemasService";
import MarketingService from "@/services/MarketingService";
import ExhibitorService from "@/services/ExhibitorService";
import moment from "moment";

export default {
  data() {
    return {
      btenable: false,
      isRoleID: true,
      submitted: false,

      add_on_id: null,

      Cinemas: [],
      CinemasCopy: [],
      selectedCinema: "",
      searchCinema: "",

      chargeSettings: [],
      chargeSettingsCopy: [],
      searchChargeSettings: "",
      selectedChargeSettings: "",

      UomList: [],
      selectedUom: "",

      add_on_object: {
        cinema_id: null,
        add_on_item_name: "",
        add_on_item_description: "",
        add_on_item_price: "",
        add_on_uom_id: null,
        add_on_max_quantity: null,
        is_tax_applicable: "N",
        is_sundry_item: "Y",
        add_on_is_active: "Y",
        pas_id: null,
        pas_charge_setting_name: null,
        net_amount: 0,
        total_amount: 0,
        created_at: null,
        updated_at: null
      },
      created_by: null,
      updated_by: null,

      extraCharges: []
    };
  },
  beforeMount() {
    let obj = this.secureStore.get("USINFO").cinema_id;
    let roleid = this.secureStore.get("USINFO").role_id;
    this.add_on_id = this.$route.query.add_on_id;
    if (this.add_on_id) {
      this.getAddonDetails();
    }
    if (true) {
      this.isRoleID = false;
    }
  },
  methods: {
    getAddonDetails: function() {
      let payload = {
        add_on_id: this.add_on_id
      };
      MasterService.GetSingleAddonDetails(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            let obj = data.Records[0];
            Object.keys(obj).map(x => {
              if (x === "created_by") {
                this.getViewUsersDetails(obj[x], "created_by");
              } else if (x === "updated_by") {
                this.getViewUsersDetails(obj[x], "updated_by");
              }
            });
            this.add_on_object = obj;
            this.getCinemasList(obj.cinema_id);
            this.getUomList(obj.add_on_uom_id);
            if (this.add_on_object.is_tax_applicable == "Y") {
              this.getAddonCharges();
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    getAddonCharges: function() {
      let payload = {
        add_on_id: this.add_on_id
      };
      MasterService.GetSingleAddonCharges(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            let obj = data.Records[0];
            this.add_on_object.pas_charge_setting_name =
              obj.pas_charge_setting_name;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    getViewUsersDetails(user_id, fieldvalue) {
      this[fieldvalue] = "-";
      if (user_id) {
        MasterService.GetUserInfoById({ user_id })
          .then(response => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this[fieldvalue] = data.Records[0].user_name;
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError); //message
      }
    },
    getCinemasList: function(cine_id) {
      MasterService.GetCinemas({ cine_id: cine_id })
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.Cinemas = data.Records;
            this.CinemasCopy = data.Records;
            this.Cinemas.map(x => {
              if (String(cine_id) === String(x.cine_id)) {
                this.onSelectCinema(x);
              }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    getUomList: function(id) {
      let payload = {
        tableName: "ms_unit_of_measurement",
        uom_is_active: "Y"
      };
      MasterService.GetActiveList(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.UomList = data.Records;
            this.UomList.map(x => {
              if (String(x.uom_id) === String(id)) {
                this.onSelectUom(x);
              }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(error => {
          this.$toasted.show(error);
        });
    },
    onSelectUom(value) {
      this.selectedUom = value.uom_unit;
      this.add_on_object.add_on_uom_id = value.uom_id;
    },
    onSelectCinema: function(params) {
      this.selectedCinema = params.cine_name;
      this.add_on_object.cinema_id = params.cine_id;
    },
    goToRoute: function() {
      this.$router.push({
        path: "/master/edit-add-ons",
        query: {
          add_on_id: this.add_on_id
        }
      });
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/AddonsComponents/viewAddons.vue